import React from 'react'
import Col from 'antd/lib/col'
import Row from 'antd/lib/row'
import { OrderInfo } from '../type'
import RefundButton from './RefundButton'

interface AcceptedType {
  order: OrderInfo
  successCallback?: () => void
  setShowRefundForm: (value?: any) => void
}

const Accepted = ({ order, setShowRefundForm }: AcceptedType) => {
  return (
    <Row className='_mb-0' justify='end' align='middle' gutter={16}>
      <Col>
        <RefundButton order={order} onClick={() => setShowRefundForm(true)} />
      </Col>
    </Row>
  )
}

export default Accepted
